import angular from "angular";

angular
	.module('app')
	.component('notificationTaskRejected', {
		template: require('./notification-task-rejected.html'),
		controller: ['$http', controller],
		bindings: {
			resolve: '<',
			close: '&',
			dismiss: '&'
		}
    });

function controller($http) {

	let $ctrl = this;

	$ctrl.$onInit = function () {
		$ctrl.notify = $ctrl.resolve.notification;
	};
}